// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9896e99d","453":"0a65cc6f","667":"912a37af","977":"616b603c"}[chunkId] + ".chunk.js";
};